import Vue from '../../../lib/utils/vue'
import { mergeData } from 'vue-functional-data-merge'

export const props = {}

// @vue/component
export const CvtNavText = /*#__PURE__*/ Vue.extend({
  name: 'CvtNavText',
  functional: true,
  props,
  render(h, { data, children }) {
    return <li {...mergeData(data)}>{children}</li>
  }
})
